<template>
  <wrapper-edit
    :wrapper-width="wrapperWidth"
    :isModify = "isModify"
    class="edit"
    @modify="getModifyRecords"
    @back="paasPageBack">
    <Form ref="paasForm" slot="form"
          :model="paasFormData"
          :rules="paasFormRules"
          :label-width="defaultLabelWidth">
      <Row>
        <FormItem label="角色名称："  prop="name" class="ivu-col-span-24" >
          <Input v-model="paasFormData.name" clearable @on-blur="addModifyRecord('name',true,'用户姓名')" ></Input>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="角色描述:" prop="sysRoleDesc"  class="ivu-col-span-24" >
          <Input v-model="paasFormData.sysRoleDesc" clearable  @on-blur="addModifyRecord('sysRoleDesc',false,'账号')"></Input>
        </FormItem>
      </Row>
      <div class="edit-oper-toolbar">
        <mButton type="blue" @click="paasFormSubmit('paasForm','','submit')">提交</mButton>
        <mButton type="green" @click="paasFormSubmit('paasForm','','add')">继续添加</mButton>
        <mButton @click="paasPageBack">返回</mButton>
      </div>
    </Form>
  </wrapper-edit>
</template>

<script>
  import wrapperEdit from "@components/paas/wrapper-edit"
  import metaEdit from '@assets/js/meta-edit.js'
  import mButton from '@components/button/m-button'
  export default {
    name: "edit",
    components:{wrapperEdit,mButton},
    mixins:[metaEdit],
    data(){
      return{
        serviceUrl:"/sys/role",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        sysModifyTraceName:'sys_role',//表单数据库名称
        fieldName:'角色管理', //表单的中文名字
        modifyTraceFiledName:'name,sysRoleDesc',//需要跟踪的字段
        paasFormData:{
          id: '',
          name: '',
          createTime:"",
          updateTime:"",
          createUserId:"",
          createUserName:"",
          isDelete:"",
          sysRoleCode:"",
          sysRoleDesc: '',
        },
        paasFormRules:{
          name: [
            { required: true, trigger: 'blur' },
            { type: 'string', trigger: 'blur', max: 20}
          ],
          sysRoleDesc: [
            { type: 'string', trigger: 'blur', max: 100}
          ]
        },
        redirectName: 'sysRoleList',
        nextAddName: 'sysRoleEdit',
        wrapperWidth:'50%',
      }
    },
    methods:{

    },
  }
</script>

<style scoped>
  .edit /deep/ .body{
    height: calc(100vh - 120px);
    overflow: auto;
  }
</style>
